"use client";

import { Fragment } from "react";

import LoadingOverlay from "~/core/ui/LoadingOverlay";

function GlobalLoadingIndicator({
  children,
  displayLogo = false,
  fullPage = false,
}: React.PropsWithChildren<{
  displayLogo?: boolean;
  fullPage?: boolean;
}>) {
  const Text = children ?? "Synchronizing...";

  return (
    <Fragment>
      <div
        className={
          "flex flex-1 flex-col items-center justify-center py-48 text-sm text-light w-full"
        }
      >
        <LoadingOverlay displayLogo={displayLogo} fullPage={fullPage}>
          {Text}
        </LoadingOverlay>
      </div>
    </Fragment>
  );
}

export default GlobalLoadingIndicator;
